import { FormField, InputSelectField } from '@tempmee/react';
import { forwardRef, memo, type Ref } from 'react';

interface IMealBreakPaidFieldProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
}

const OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const Component = (
  { value, onChange }: IMealBreakPaidFieldProps,
  ref: Ref<HTMLDivElement>,
) => (
  <div ref={ref} data-testid="meal-break-paid-field" data-cy="meal-break-paid-field">
    <FormField label="Meal Break Paid">
      <InputSelectField<boolean>
        options={OPTIONS}
        value={value}
        onChange={onChange}
        placeholder="Select"
      />
    </FormField>
  </div>
);

export const MealBreakPaidField = memo(forwardRef(Component));
